import React, { useState } from "react";
import {
  Typography,
  Box,
  Modal,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import BackdropImage from "../../Images/Universal/Login.png";
import { useTranslation } from "react-i18next";

function CancelAppointmentModal({
  showModal,
  setshowModal,
  cancelCall,
  cancelObject,
}) {
  // 1) Data
  const { t } = useTranslation();
  // 3) Function

  return (
    <>
      <Modal
        open={showModal}
        onClose={() => {
          setshowModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="p-10 h-full" style={{ backgroundImage: BackdropImage }}>
          <Box sx={style} className="GlassEffectModal">
            <div className="p-10"></div>

            {/* Main section */}
            <div className="px-2">
              <div className="text-center mt-0">
                <div className=" flex justify-center items-center mt-1 ">
                  {/* <ArrowForwardIcon className="m-1" /> */}
                  <p className="text-2xl text-gray-700 font-semibold">
                    {t("Ακύρωση_Ραντεβού")}
                  </p>
                </div>
              </div>

              <div className="p-2">
                <Grid container mb={1}>
                  <>
                    <Grid container mb={1} className="justify-center ">
                      <Typography className="text-center justify-center">
                        {t(
                          "Σίγουρα_θέλετε_να_ακυρώσετε_το_ραντεβού_με_τα_παρακάτω_στοιχεία;"
                        )}
                      </Typography>
                    </Grid>
                    <Grid container className="justify-center ">
                      <Typography className=" justify-center">
                        {cancelObject !== undefined && (
                          <>
                            {t("Ημερομηνία") +
                              " : " +
                              cancelObject.info.reservationDate.split("T")[0]}
                            <br />
                            {t("Time") +
                              " : " +
                              cancelObject.info.reservationDate.split("T")[1]}
                            <br />
                            {t("Destination") +
                              " : " +
                              cancelObject.info.destination}
                            <br />
                            {t("Customer") +
                              " : " +
                              cancelObject.info.customerName}
                          </>
                        )}
                      </Typography>
                    </Grid>
                  </>
                </Grid>
              </div>
            </div>

            <div className="p-3"></div>

            {/* Buttons */}
            <div className="p-4"></div>
            <Divider />
            <Grid container className="text-center">
              <Grid
                item
                xs={6}
                className="flex  Primary_Main_Background text-gray-700 justify-center items-center p-4 cursor-pointer rounded-bl-md"
                onClick={() => {
                  cancelCall(cancelObject);
                  setshowModal(false);
                }}
              >
                <p className="font-semibold w-full h-full hover:scale-125  ">
                  {t("YES")}
                </p>
              </Grid>
              <Grid
                item
                xs={6}
                onClick={() => setshowModal(false)}
                className="flex  Primary_Dark_Background Primary_Light_Text justify-center items-center p-4 cursor-pointer rounded-br-md"
              >
                <p className="font-semibold w-full h-full hover:scale-125 ">
                  {t("ΟΧΙ")}
                </p>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 550,
  borderRadius: 2,
  boxShadow: 24,
  //background: "#fff",
};

export default CancelAppointmentModal;
